import React from 'react';
import PropTypes from 'prop-types';
import s from './Textarea.css';
import { Checkbox, Input, Form } from 'antd';

class Textarea extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    ontextchange: PropTypes.func.isRequired,
    showsaveoption: PropTypes.bool,
    onsavechange: PropTypes.func,
    templatenamechange : PropTypes.func,
    onunicodechange : PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      chars_count: 0,
      text: "",
      messages: 0,
      isIsl: false,
      messageMaxLength: 480,
      save: false
    };
    this.onTextInput = this.onTextInput.bind(this);
  }

    componentDidMount() {
        this.checkMessageLength(this.props.value != undefined ? this.props.value : "");
    }


  componentWillReceiveProps(nextProps) {
    this.checkMessageLength(nextProps.value != undefined ? nextProps.value : "");
  }

  checkMessageLength(text){
    let isIsl = !this.isGSM(text),
      textLength = text.length,
      messageSize = this.getChunkSize(textLength, isIsl),
      messages = Math.ceil(textLength / messageSize),
      limit = 10 * messageSize,
      dis_length = ( messageSize * messages) - textLength;
    if(this.props.onunicodechange != undefined) {
        this.props.onunicodechange(isIsl);
    }
    if(textLength > limit){
      text = text.substr(0, limit);
      this.setState({
        text: text,
        chars_count: 0,
        messageMaxLength : limit
      });
      return;
    }
    this.setState({
      text: text,
      chars_count: dis_length,
      messages: messages,
      isIsl: isIsl,
      messageMaxLength : limit
    });
  }

  getChunkSize(length, isIsl) {
    if (isIsl) {
      return length > 70 ? 67 : 70;
    }
    return length > 160 ? 153 : 160;
  }

  onTextInput(text) {

    this.props.ontextchange(text);
  }

  isGSM = (value) => {
    const gsm = [10, 13, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
      50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
      73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 95, 97, 98, 99, 100,
      101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
      119, 120, 121, 122, 161, 163, 164, 165, 167, 191, 196, 197, 198, 199, 201, 209, 214, 216,
      220, 223, 224, 228, 229, 230, 232, 233, 236, 241, 242, 246, 248, 249, 252];
    for (let i = 0; i < value.length; i += 1) {
      if (gsm.find(code => code === value.charCodeAt(i)) === undefined) return false;
    }
    return true;
  };

  render() {
    const { ontextchange, showsaveoption,onsavechange, onunicodechange, templatenamechange, ...props } = this.props;
    return (
      <div className={s.root}>
          <textarea
            maxLength={this.state.messageMaxLength}
            className={s.field}
            value={this.state.text}
            {...props}
            onChange={(e) => this.onTextInput(e.target.value)}
            id="messageArea"
          />
        <div className={s.textarea_footer}>
          <div className={s.textarea_template}>
            {this.state.save ?
                <Form.Item className={s.textarea_item} help="">
                        <Input
                            size="small"
                            placeholder="Nafn á forsniði"
                            className={s.textarea_input}
                            onChange={(event) => { this.props.templatenamechange(event.target.value); }}
                        />
                </Form.Item>
                : ''}
            {this.props.showsaveoption ?
                <Checkbox
                    className={s.textarea_checkbox}
                    onChange={(event) => {
                        this.props.onsavechange(event.target.checked);
                        this.state.save = event.target.checked;
                    }}
                >
                    <span className={s.textarea_label}>Vista texta</span>
                </Checkbox>
            :""}
          </div>
          <span className={s.letters}>
            {this.state.isIsl ? <i className={s.flag_img} title="Hámarks lengd á SMS skeyti með íslenskum stöfum er 70 stafabil í hverju SMS skeyti" /> : null}
            {this.state.chars_count} / {this.state.messages}
          </span>
        </div>
      </div>
    );
  }
}

export default (Textarea);



// WEBPACK FOOTER //
// ./src/components/Textarea/Textarea.js